"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertToLogObject = convertToLogObject;
exports.roundToDecimals = roundToDecimals;
function valueOrStringIfNotDefined(v) {
  return v ? v : String(v);
}

function convertToLogObject(objectToLog) {
  return Object.keys(objectToLog).reduce(function (logObject, key) {
    logObject[key] = valueOrStringIfNotDefined(objectToLog[key]);
    return logObject;
  }, {});
}

// use exponential notation to round numbers to avoid rounding errors
// https://www.jacklmoore.com/notes/rounding-in-javascript/
function roundToDecimals(number, decimals) {
  var multiplied = Math.round(number + "e" + decimals);
  return Number(multiplied + "e-" + decimals);
}